import { useState } from 'react';

import {
  Flex, Box, Portal,
  Menu, MenuList, MenuOptionGroup, MenuItem, MenuButton
} from "@chakra-ui/react";

import { LuFlag } from 'react-icons/lu';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import { IoChevronDownOutline } from 'react-icons/io5';
import FormTextAreaInput from '../../forms/TextareaField/components/FormTextAreaInput';
import WarningTextMessage from '../../global/components/helper-components/components/WarningTextMessage';
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal';


export default function DsrReportModal({
  handleCloseModal,
  showDsrModalLoader,
  modalTransferPayload,
  handleReportPost,
  handleReportReply,
  formType
}) {

  const [showInput, setShowInput] = useState(null)
  const [showError, setShowError] = useState(null)

  const [showNoReasonError, setShowNoReasonError] = useState(null)
  const [reportReason, setReportReason] = useState("")
  const [reportReasonNotes, setReportReasonNotes] = useState("")

  function onChangeHandler(event) {
    if (event.target.name === "report-reason-notes") {
      setReportReasonNotes(event.target.value)
      !!showError && setShowError(false)
    }
  }

  const handleSendReport = () => {
    const trimmedReportNotes = reportReasonNotes ? reportReasonNotes.trim() : "";

    if (!reportReason) {
      setShowNoReasonError(true)
    } else {
      if (showInput && !trimmedReportNotes) {
        setShowError(true)
      } else {
        if (formType === "report-post") {
          const { postId } = modalTransferPayload || {}

          if (postId) {
            handleReportPost(postId, { reportReason, reportReasonNotes })
          }
        } else if (formType === "report-reply") {
          const { postId, replyId } = modalTransferPayload || {}

          if (postId && replyId) {
            handleReportReply(postId, replyId, { reportReason, reportReasonNotes })
          }
        }

      }
    }
  }


  const handleSelectReason = (reason, shouldHideInput = false) => {
    setReportReason(reason);
    setShowNoReasonError(false);
    // Ensure state updates correctly by batching the updates
    setShowInput(!shouldHideInput);
  };


  function displayContent() {
    const renderReasonsListDropdown = () => {
      return (
        <Menu closeOnSelect={true} isOpen={!showDsrModalLoader && undefined}>
          <MenuButton w='100%' isDisabled={showDsrModalLoader}>
            <Flex position='relative' w='100%' bg='white' border='1px solid' borderColor={showNoReasonError ? "brandPink.500" : 'gray.200'} rounded='0.25em' p='0.4em 1em' justify='space-between' align='center'
              opacity={showDsrModalLoader ? 0.6 : 1} // Optional: Grey out when disabled
              cursor={showDsrModalLoader ? "not-allowed" : "pointer"}
            >
              <Box position='absolute' color='gray.500' fontSize='0.75em' bottom='2.6em' bg='white'>Why report?</Box>
              <Flex py='0.2em' w='100%' fontSize='0.875em' fontWeight={reportReason && "600"}> {reportReason ? reportReason : "Select a reason"}</Flex>
              <Box as={IoChevronDownOutline} fontSize='0.875em' />
            </Flex>
          </MenuButton>
          <WarningTextMessage errorLogic={showNoReasonError} message={`Why are you reporting this post?`} />
          <Portal>

            <MenuList minWidth='240px' zIndex='5000'>

              <MenuOptionGroup title='Report' fontSize='0.75em' color='brandPink.500'>
                <MenuItem pl='2em' onClick={() => handleSelectReason("Contains offensive content", true)
                } fontSize='0.8em'>Offensive content</MenuItem>
                <MenuItem pl='2em' onClick={() => handleSelectReason("Other reasons", false)
                } fontSize='0.8em'>Other reasons</MenuItem>
              </MenuOptionGroup>

            </MenuList>

          </Portal>
        </Menu>
      )
    }
    return (

      <Box w='100%' p='1em 1.8em'>
        <Flex gap='1em' direction='column' fontSize='0.875em' mt={'1em'}>
          <Box>{renderReasonsListDropdown()}</Box>
          {!!showInput &&
            <Box>
              <FormTextAreaInput
                name={'report-reason-notes'}
                fontSize='0.875em'
                borderColor={showError && "brandPink.500"}
                //  isRequiredField={true}
                isDisabled={showDsrModalLoader}
                placeholder={`Provide some information to help Room administrators understand better`}
                currentValue={reportReasonNotes}
                charLimit={255}
                onChange={onChangeHandler}
                minH="6em"
              />
              <WarningTextMessage errorLogic={showError} message={`Please provide some details to this`} />
            </Box>
          }
        </Flex>

        <Flex mt='1.625em' w='100%' justify={['center', 'flex-end']}>
          <LaunchdeckButton bg='brandPink.500' w={['100%', 'auto']} color='gray.50' fontSize='0.8em' py='0.4em' loadingLogic={showDsrModalLoader} onClick={() => handleSendReport()} label='Report & hide post' />
        </Flex>
      </Box>
    )
  }



  return (
    <LaunchdeckModal
      title={<Flex gap='1em' justify='flex-start' align='center'>
        <Box as={LuFlag} color='brandPink.500' boxSize="1.6em" />
        <Box color='white'>Report this post</Box>
      </Flex>}
      handleCloseModal={() => handleCloseModal()}
      showModal={true}
      maxW='35em'
      noCancelOption={!!showDsrModalLoader}
    >
      {displayContent()}
    </LaunchdeckModal>
  )
}
